import useDocumentTitle from "hooks/useDocumentTitle";
import { useForm, FormProvider } from "react-hook-form";

import { Aliases } from "./components/Aliases";
import { GroupNumbers } from "./components/GroupNumbers";
import { Header } from "./components/Header";
import { MedtelIds } from "./components/MedtelIds";
import { MemberIdPrefixes } from "./components/MemberIdPrefixes";
import { Parent } from "./components/Parent";
import { PayerName } from "./components/PayerName";
import { PverifyId } from "./components/PverifyId";
import { SecondaryAbsorbsFullResponsibility } from "./components/SecondaryAbsorbsFullResponsibility";
import { SubmitPayer } from "./components/SubmitPayer";

export function CreatePayerPage() {
  useDocumentTitle("Create Payer");

  const methods = useForm({
    defaultValues: {
      name: "",
      type: "Commercial",
      parent: [],
      pverifyId: [],
      aliases: [],
      memberIdPrefixes: [],
      groupNumbers: [],
      groupNumberMode: "INCLUDE",
      secondaryAbsorbsFullResponsibility: false,
    },
  });
  return (
    <FormProvider {...methods}>
      <Header isPayer />
      <PayerName />
      <Parent />
      <PverifyId />
      <MedtelIds />
      <Aliases />
      <MemberIdPrefixes />
      <GroupNumbers />
      <SecondaryAbsorbsFullResponsibility />
      <SubmitPayer />
    </FormProvider>
  );
}
